module.exports = __webpack_public_path__ + "static/media/pra-emoji.5cf3b3e4.png";